function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 52,
  height: 52,
  rx: 8,
  fill: "#FEEEEA"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M21.5 33.5H27.5C28.325 33.5 29.0315 33.2065 29.6195 32.6195C30.2065 32.0315 30.5 31.325 30.5 30.5V28.25C30.5 27.6 30.2875 27.0625 29.8625 26.6375C29.4375 26.2125 28.9 26 28.25 26C28.9 26 29.4375 25.7875 29.8625 25.3625C30.2875 24.9375 30.5 24.4 30.5 23.75V21.5C30.5 20.675 30.2065 19.9685 29.6195 19.3805C29.0315 18.7935 28.325 18.5 27.5 18.5H21.5V21.5H27.5V24.5H24.5V27.5H27.5V30.5H21.5V33.5ZM15.5 39.5C14.675 39.5 13.9685 39.2065 13.3805 38.6195C12.7935 38.0315 12.5 37.325 12.5 36.5V15.5C12.5 14.675 12.7935 13.9685 13.3805 13.3805C13.9685 12.7935 14.675 12.5 15.5 12.5H36.5C37.325 12.5 38.0315 12.7935 38.6195 13.3805C39.2065 13.9685 39.5 14.675 39.5 15.5V36.5C39.5 37.325 39.2065 38.0315 38.6195 38.6195C38.0315 39.2065 37.325 39.5 36.5 39.5H15.5ZM15.5 36.5H36.5V15.5H15.5V36.5Z",
  fill: "#F2512D"
});

function SvgStepInfo3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepInfo3);
export default __webpack_public_path__ + "static/media/step_info_3.9079f4c7.svg";
export { ForwardRef as ReactComponent };